import { render, staticRenderFns } from "./AccountStatementReportList.vue?vue&type=template&id=aafb573e"
import script from "./AccountStatementReportList.vue?vue&type=script&lang=js"
export * from "./AccountStatementReportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports